<template>
    <div>
        <MarketplaceAutomationTemplateCard
            v-if="isMarketplace"
            :template="template"
            class="automation-card">
            <div slot="card-footer" class="automation-card-footer">
                <slot name="card-footer"></slot>
            </div>
        </MarketplaceAutomationTemplateCard>
        <!-- Other automation cards -->
        <div v-else class="automation-card">
            <div class="d-flex align-items-center w-100 py-3">
                <div class="col-6">
                    <AutomationCategoryIcon
                        v-for="catId in template.categories"
                        :key="catId"
                        :uuid="catId"
                        class="px-2 font-18"/>
                </div>
                <div class="col-6">
                    <div class="text-right">
                        <div v-for="(param, idx) in authParams" :key="idx" class="d-inline-block">
                            <AppLogo
                                :app="getAuthParamApp(param)"
                                :size="24"
                                class="d-inline-block align-middle border"/>
                            <div v-if="idx < authParams.length - 1"
                                 class="d-inline-block align-middle font-14 px-2">
                                <i class="fal fa-chevron-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-auto p-3 pb-5">
                <AutomationSentenceDisplayValue :automation="template" :fontSize="20"/>
            </div>
            <div class="automation-card-footer">
                <slot name="card-footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import AutomationSentenceDisplayValue from '../../../../components/automation/AutomationSentenceDisplayValue.vue'
import AutomationCategoryIcon from '../../categories/AutomationCategoryIcon'
import {getRecipeAuthParams} from '../../builder/hooks/auth'
import AppLogo from '../../../apps/AppLogo'
import {AutomationTypes} from '@/types/automations/types'
import MarketplaceAutomationTemplateCard from './marketplace/MarketplaceAutomationTemplateCard'

export default {
    name: 'AutomationTemplateCard',
    inject: ['getAvailableApps'],
    components: {MarketplaceAutomationTemplateCard, AppLogo, AutomationCategoryIcon, AutomationSentenceDisplayValue},
    props: {
        template: { // Automation
            type: Object,
            required: true
        }
    },
    computed: {
        /**
         *  NOTE: currently automation type restricted to one value
         */
        typeModel() {
            return _.get(this.template.types, 0)
        },

        type() {
            return _.get(this.typeModel, 'uuid')
        },

        isMarketplace() {
            return this.type === AutomationTypes.MARKETPLACE
        },

        authParams() {
            return getRecipeAuthParams(this.template.recipe)
        }
    },
    methods: {
        getAuthParamApp(param) {
            const appUuid = _.get(param, 'default.app.uuid')
            return this.getAvailableApps().find(app => app.uuid === appUuid)
        }
    }
}
</script>

<style scoped lang="scss">
.automation-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 4px;
    box-shadow: $box-shadow-sm;
    border: 1px solid lighten($color-grey-light, 8%);
    background-color: #ffffff;
    font-size: 20px;
    transition: box-shadow 0.5s;
    justify-content: space-between;

    &:hover {
        box-shadow: $box-shadow;
        cursor: pointer;
    }
}

.automation-card-footer {
    width: 100%;
    padding: 12px;
    background: #f8f9fa;
    color: $color-purple-light;
    border-radius: 0 0 4px 4px;
    font-size: 14px;

    &:hover {
        cursor: pointer;
    }
}

</style>
